import { useCallback, useReducer } from 'react'

export const snapToBounds = (min: number, max: number, value: number) => {
  if (value > max) return max
  if (value < min) return min
  return value
}

export const snapToStep = (value: number, step: number) => {
  const fullSteps = Math.round(value / step)
  return fullSteps * step
}

type RangeValue = { from: number; to: number }
type Props = {
  min: number
  max: number
  step: number
  value: RangeValue
}
export const useRangeValue = ({ max, min, step, value: { from, to } }: Props) => {
  const reducer = useCallback(
    (prevValue: RangeValue, { from, to }) => {
      const snappedFrom = snapToStep(from, step)
      const snappedTo = snapToStep(to, step)

      if (prevValue.from !== snappedFrom) {
        // We are changing from value and should cap it *to currently active* "to" value
        return {
          from: snapToBounds(min, prevValue.to, snappedFrom),
          to
        }
      }

      if (prevValue.to !== snappedTo) {
        // We are changing to value and should cap it to currently active "from" value
        return {
          from,
          to: snapToBounds(prevValue.from, max, snappedTo)
        }
      }

      return {
        from: snappedFrom,
        to: snappedTo
      }
    },
    [max, min, step]
  )

  return useReducer(reducer, { from: Math.max(from, min), to: Math.min(to, max) })
}
